export const LABELS_DATA = [
  {
    key: 'propertyTypeName',
    content: 'Property Type'
  },
  {
    key: 'valueDate',
    content: 'Sold Date'
  },
  {
    key: 'valueAmount',
    content: 'Sold Price'
  },
  {
    key: 'bedCount',
    content: 'Beds'
  },
  {
    key: 'bath',
    content: 'Bath'
  },
  {
    key: 'buildingSize',
    content: 'GLA'
  },
  {
    key: 'pricePerSquareFoot',
    content: '$/sqft'
  },
  {
    key: 'lotSize',
    content: 'Lot Size'
  },
  {
    key: 'yearBuilt',
    content: 'Year Built'
  },
  {
    key: 'levelsCount',
    content: 'Levels'
  },
  {
    key: 'heatingCooling',
    content: 'Heating / Cooling'
  },
  {
    key: 'firePlaceTypeName',
    content: 'Fireplace'
  },
  {
    key: 'garageTypeName',
    content: 'Garage'
  },
  {
    key: 'styleName',
    content: 'Property Style'
  },
  {
    key: 'apn',
    content: 'APN'
  }
]
